/**
 * Authentication loading component
 * Displays loading state during authentication process
 */

import { cn } from "@/shared/ui/lib"

export interface AuthLoadingProps {
	className?: string
	loadingText: string
}

/**
 * Component that displays loading state during authentication
 * Provides visual feedback to user that authentication is in progress
 */
export function AuthLoading({ className, loadingText }: AuthLoadingProps) {
	return (
		<div
			className={cn(
				"min-h-screen flex items-center justify-center bg-background",
				className,
			)}
		>
			<div className="text-center space-y-4">
				{/* Loading spinner */}
				<div className="flex justify-center">
					<div className="size-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
				</div>
				{/* Loading text */}
				<p className="text-muted-foreground">{loadingText}</p>
			</div>
		</div>
	)
}
